module.exports = __webpack_public_path__ + "media/landing_page/instacart-logo-white-4ac3da2e.png";